import React, { lazy, Suspense, useState } from 'react'
import '../../styles/HomeScreen.css'
import i18n from '../../i18n'
import TaskMascot from '../../svg/UpstriveTaskMaskot'
import RewardingTasksHeader from './RewardingTasksHeader'
import { useUser } from '../../context/user'
import Dumo from './Dumo'
import RewardingFeedHeader from './RewardingFeedHeader'
import InstructionVideoModal from '../Modal/InstructionVideoModal'
import Instruction from './Instruction'
import FeedSkeleton from './skeleton/FeedSkeleton'
import TasksSkeleton from './skeleton/TasksSkeleton'

const FeedSection = lazy(
    () =>
        new Promise((resolve) => {
            setTimeout(() => resolve(import('./FeedSection')), 1000)
        })
)
const Tasks = lazy(
    () =>
        new Promise((resolve) => {
            setTimeout(() => resolve(import('./Tasks')), 1000)
        })
)

function HomeScreen() {
    const { rewardingSystemEnabled } = useUser()
    const [rewardingSelection, setRewardingSelection] = useState('tasks')
    const [instructionVideoVisible, setInstructionVideoVisible] = useState(false)
    const [instructionContainerVisible, setInstructionContainerVisible] = useState(true)

    const toggleInstructionVideo = () => {
        setInstructionVideoVisible(!instructionVideoVisible)
    }

    const closeVideoContainer = () => {
        setInstructionContainerVisible(false)
    }

    const handleRewardingButton = (select) => {
        if (select !== rewardingSelection) {
            setRewardingSelection(select)
        }
    }

    return (
        <div id="feedid" className="home-container" style={{ zIndex: 2 }}>
            <div className={`home-tasks-section ${i18n.language === 'ar' ? 'ar-lang' : ''}`}>
                <div className="home-task-list shadow-custom-soft">
                    {rewardingSystemEnabled && <RewardingTasksHeader rewardingSelection={rewardingSelection} handleRewardingButton={handleRewardingButton} />}
                    {rewardingSelection === 'tasks' ? (
                        <Suspense fallback={<TasksSkeleton />}>
                            <Tasks />
                        </Suspense>
                    ) : (
                        <Dumo />
                    )}
                </div>
            </div>
            <div className={`home-feed-section  ${i18n.language === 'ar' ? 'ar-lang' : ''}`}>
                {rewardingSystemEnabled && rewardingSelection === 'tasks' && <RewardingFeedHeader />}
                <Suspense fallback={<FeedSkeleton count={5} />}>
                    <FeedSection />
                </Suspense>
            </div>
            {/* {instructionContainerVisible && <Instruction closeVideoContainer={closeVideoContainer} toggleInstructionVideo={toggleInstructionVideo} />} */}
            {/* <InstructionVideoModal isOpen={instructionVideoVisible} onRequestClose={toggleInstructionVideo} /> */}
        </div>
    )
}

export default HomeScreen
